<template lang="pug">
v-card
    v-toolbar(flat dense)
        v-tabs(v-model="tab")
            v-tab Artists
            v-tab(v-if="$accessable(['usersCreate', 'usersRemove'])") Artists Request
            v-tab(v-if="$accessable(['usersCreate', 'usersRemove'])") Create Artists

    v-tabs-items(v-model="tab")
        artist-lists
        artist-request(v-if="$accessable(['usersCreate', 'usersRemove'])")
        create-artists(v-if="$accessable(['usersCreate', 'usersRemove'])")
</template>

<script>
import ArtistLists from './components/ArtistLists.vue';
import ArtistRequest from './components/ArtistRequest.vue';
import CreateArtists from './components/CreateArtists.vue';

export default {
    data() {
        return {
            tab: 0
        };
    },
    components: {
        ArtistLists,
        ArtistRequest,
        CreateArtists
    }
}
</script>